"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeProcessorTask = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var types_1 = require("../types");
var TimeProcessorTask = /** @class */ (function () {
    function TimeProcessorTask() {
    }
    TimeProcessorTask.prototype.addTimingFields = function (data) {
        var adjustTimeReady = this.adjustTimeService.isReady();
        var now = Date.now();
        var startTime = data.startTime, rest = __rest(data, ["startTime"]);
        if (!rest.ts) {
            rest.ts = now + (data.offset || 0);
        }
        // 这个if目的是修复 adt 值的正确性
        // 没有设置过adt || adt 给的是 -1 都是表明数据需要修复的
        if (!rest.adt || rest.adt === -1) {
            // 对时服务不可用情况下将 adt 回退为 -1，并标记开始时间为系统当前时间
            // 直到对时服务可以用后将重新校准 adt 的值
            if (adjustTimeReady) {
                var timestamp = this.adjustTimeService.getTimestamp() || now;
                if (startTime && typeof startTime === "number") {
                    // 系统当前时间 >= 保存的系统开始时间 即正常
                    // 系统当前时间 < 保存的系统开始时间，即开始时间发生在未来？属于异常数据，标记为 -1
                    timestamp = now >= startTime ? timestamp - (now - startTime) : -1;
                }
                rest.adt = timestamp;
            }
            else {
                rest.startTime = startTime || now;
                rest.adt = -1;
            }
        }
        return rest;
    };
    TimeProcessorTask.prototype.transform = function (data) {
        var _this = this;
        if (data.eventType !== types_1.EventType.Expose && data.eventType !== types_1.EventType.Input) {
            data = this.addTimingFields(data);
        }
        if (data.eventType === types_1.EventType.Input) {
            data.inputList = (data.inputList || []).map(function (il) { return _this.addTimingFields(il); });
        }
        if (data.eventType === types_1.EventType.Expose) {
            data.listInfo = (data.listInfo || []).map(function (li) { return _this.addTimingFields(li); });
        }
        if (data.eventType === types_1.EventType.Statistics) {
            data.statisticsList = (data.statisticsList || []).map(function (sl) { return _this.addTimingFields(sl); });
        }
        return data;
    };
    TimeProcessorTask.prototype.execute = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                context.list = context.list
                    .map(function (data) {
                    return _this.transform(data);
                })
                    .filter(function (v) { return v; });
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IAdjustTimeService),
        __metadata("design:type", Object)
    ], TimeProcessorTask.prototype, "adjustTimeService", void 0);
    TimeProcessorTask = __decorate([
        (0, inversify_1.injectable)()
    ], TimeProcessorTask);
    return TimeProcessorTask;
}());
exports.TimeProcessorTask = TimeProcessorTask;
